// extracted by mini-css-extract-plugin
export default {"label":"label-10bd"};